import { useNavigate } from 'react-router-dom';

interface InsufficientCreditsModalProps {
  creditsNeeded: number;
  onClose: () => void;
}

const InsufficientCreditsModal = ({ creditsNeeded, onClose }: InsufficientCreditsModalProps) => {
  const navigate = useNavigate();

  const handleBuyCredits = () => {
    onClose();
    navigate('/pricing');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm mx-4 overflow-hidden">
        <div className="p-6 text-center">
          <div className="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-coin-line text-amber-500 text-2xl"></i>
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Not enough credits</h2>
          <p className="text-gray-500 text-sm mb-6">
            You need <span className="font-semibold text-gray-900">{creditsNeeded} credits</span> to use this feature. Buy more credits to continue.
          </p>
          <button
            onClick={handleBuyCredits}
            className="w-full bg-gray-900 text-white font-semibold py-3 rounded-xl hover:bg-gray-800 transition-colors cursor-pointer mb-3"
          >
            Buy Credits
          </button>
          <button
            onClick={onClose}
            className="w-full text-gray-500 text-sm font-medium py-2 cursor-pointer hover:text-gray-700"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsufficientCreditsModal;
